'use client';
/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';
import { GrPlayFill } from 'react-icons/gr';
import { useMediaQuery } from 'react-responsive';
import YouTube from 'react-youtube';
// import ReactPlayer from 'react-player';

/* Internal Imports */
/* Components */
import MidContainer from '@app-ps/Components/Layout/MidContainer';
import { getEmbedUrl } from '@app-ps/Components/Utility/utils';

/* Services */
import { isInViewport } from '@app-ps/Utility/Shared/SharedService';

/* Styles */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * Renders MediaEmbed V2 component
 * @param {object} sectionContent - Data for Section
 * @param margin
 * @param width
 * @param pxBase
 * @returns {ReactElement} MediaEmbed V2 component
 */

const MediaEmbedV2 = ({ sectionContent, margin, width, lang, ...props }) => {
  // console.log(sectionContent);

  const [vidVis, setVidVis] = useState(false);
  const [opts, setOpts] = useState({});
  // Set icon size dynamically based on the screen width
  const iconSize = useBreakpointValue({ base: '22px', md: '34px' });
  const iconHeight = useBreakpointValue({ base: '40px', md: '37px' });
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  useEffect(() => {
    setOpts({
      height: isMobile ? '200px' : '420px',
      //height: '315',
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global?.window, isMobile]);

  useEffect(() => {
    if (props.autoplay) {
      window.addEventListener('scroll', listenToScroll);
    }
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const listenToScroll = () => {
    const scrollDiv = document.getElementById(props['sectionId']);
    const inViewPort = isInViewport(scrollDiv);
    if (!vidVis && inViewPort) {
      setVidVis(true);
    }

    // console.log('sdsdsd', props['sectionId'], inViewPort);
    // const heightToHideFrom = window.innerHeight / 1.5;
    // const winScroll = document.body.scrollTop ||
    //   document.documentElement.scrollTop;

    // if (winScroll > heightToHideFrom) {
    //   setVidVis(true);
    // }
  };

  const onReady = event => {
    event.target.playVideo();
  };

  const playerOverlay = (
    <Flex
      position="relative"
      top={0}
      bottom={0}
      left={0}
      right={0}
      justifyContent="center"
      alignItems="center"
      display={vidVis ? 'none' : 'flex'}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        w={{ base: '48px', md: '84px' }}
        h={{ base: '48px', md: '84px' }}
        rounded={props.round || 'full'}
        background={props.bgcolor}
        _hover={{
          background: '#E19502',
        }}
        // _hover={{
        //   boxShadow: ' -4px 14px 22px -5px rgba(0,0,0,0.66)',
        // }}
        textAlign="center"
        fontSize={{ base: '15px', md: '30px' }}
        onClick={e => setVidVis(!vidVis)}
        display={vidVis ? 'none' : 'flex'}
        color={props.txtcolor || ''}
      >
        <Box
          height={{ md: '85px' }}
          width="100%"
          opacity={0.8}
          bgColor="#D9D9D9"
          borderRadius="50%"
          boxShadow="md"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <GrPlayFill style={{ width: iconSize, height: iconHeight }} />
        </Box>
      </Flex>
    </Flex>
  );

  if (
    sectionContent?.thumbnailDesktopImage?.url ||
    sectionContent?.video?.thumbnailUrl
  ) {
    return (
      <MidContainer w={width || '762'} h="100%" background="black">
        <Box
          backgroundImage={
            !vidVis
              ? sectionContent?.thumbnailDesktopImage?.url ||
                sectionContent?.video?.thumbnailUrl
              : 'none'
          }
          bgSize="contain"
          backgroundSize="100%"
          // backgroundColor="#000"
          backgroundRepeat="no-repeat"
          backgroundPosition={
            sectionContent.id === '170001416' ? 'left' : 'center'
          }
          width="100%"
          position="relative"
          display="flex"
          // boxShadow="0px 31px 20px -13px rgba(0,0,0,0.47)"
          justifyContent="center"
          alignItems="center"
          flexDir="column"
          cursor="pointer"
          // onClick={e => setVidVis(!vidVis)}

          top="0px"
          borderRadius={props.round || { base: '0px', md: 'none' }}
          height={{ base: '193px', sm: '200px', md: '400px' }}
          m={margin || '0 auto 30px auto'}
          id="embed-vid"
          // boxShadow="0px 13px 13px -8px rgba(0,0,0,0.75)"
          {...props}
        >
          {playerOverlay}

          {vidVis && (
            <Box maxW="100%" w="full" height={{ base: '200px', md: '390px' }}>
              <YouTube
                videoId={getEmbedUrl(sectionContent?.video?.url)}
                onReady={onReady}
                opts={opts}
                loading="eager"
              />{' '}
            </Box>
          )}
        </Box>
      </MidContainer>
    );
  }

  return (
    <MidContainer w={width || '100%'}>
      <Box
        // backgroundImage={sectionContent?.video?.thumbnailUrl}
        backgroundSize="cover"
        backgroundColor="#000"
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
        width="100%"
        position="relative"
        // boxShadow="0px 13px 13px -8px rgba(0,0,0,0.75)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDir="column"
        cursor="pointer"
        onClick={() => setVidVis(!vidVis)}
        overflow="hidden"
        height={{ base: '300px', md: '430px' }}
        m={margin || '0 auto 30px auto'}
        id="embed-vid"
        border={{ base: '8px solid white', md: '15px solid white' }}
      >
        {vidVis && (
          <Box maxW="100%" w="full">
            <YouTube
              videoId={getEmbedUrl(sectionContent?.video?.url)}
              onReady={onReady}
              opts={opts}
              loading="lazy"
            />{' '}
          </Box>
        )}
      </Box>
    </MidContainer>
  );
};

export default MediaEmbedV2;
